import { memo } from 'react'

export const Toolbar = memo(() => {
  return (
    <div></div>
  )
})